import MenuDispatcher from './MenuDispatcher.jsx';

export default function ExoMenu({ itemList = [], isMobile = false }) {
  return (
    <nav
      aria-label="Global"
      className={`lds-header-exo ${
        isMobile ? 'lds-header-exo-mobile' : 'wrapper'
      }`}
    >
      <ul className="lds-header-menu lds-header-menu-exo lds-header-menu-right">
        {itemList.map((item, index) => (
          <MenuDispatcher key={index} menuType="exo" index={index} isMobile={isMobile} {...item} />
        ))}
      </ul>
    </nav>
  );
}
